import Icons from '@/shared/components/icon/Icons'
import { Caption } from '@/shared/components/typography'

const CautionView = () => {
  return (
    <div className="my-[24px] px-[16px]">
      <div className="flex w-full items-start justify-center rounded-md bg-020 px-[16px] py-[12px]">
        <div className="mt-[3px] h-[18px] w-[18px] shrink-0">
          <Icons.YellowCautionIcon18 />
        </div>
        <div className="ml-[8px]">
          <Caption level="caption2" weight="regular" color="text070">
            현장 정보와 일치하지 않아 발생한 피해는 모두의주차장이 책임을 지거나 보상하지 않습니다.
          </Caption>
        </div>
      </div>
    </div>
  )
}

export default CautionView
